import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function InactiveLabours() {
  const navigate = useNavigate();
  const [labours, setLabours]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [search, setSearch]           = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { label:"Dashboard",        emoji:"🏠", path:"/carpenter/dashboard" },
    { label:"My Labours",       emoji:"👷", path:"/carpenter/labours" },
    { label:"Add Labour",       emoji:"➕", path:"/carpenter/add-labour" },
    { label:"Attendance",       emoji:"📋", path:"/carpenter/attendance" },
    { label:"Payments",         emoji:"💰", path:"/carpenter/payments" },
    { label:"Salary",           emoji:"💵", path:"/carpenter/salary" },
    { label:"Inactive Labours", emoji:"♻️", path:"/carpenter/inactive-labours", active:true },
  ];

  const fetchInactiveLabours = async () => {
    setLoading(true);
    try {
      const res = await api.get("/labour/inactive");
      setLabours(res.data.data || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchInactiveLabours(); }, []);

  const restoreLabour = async (id) => {
    if (!window.confirm("Restore this labour?")) return;
    try {
      await api.put(`/labour/activate/${id}`);
      fetchInactiveLabours();
    } catch (err) {
      console.error(err);
      alert("Failed to restore labour");
    }
  };

  const filtered = labours.filter((l) =>
    l.name?.toLowerCase().includes(search.toLowerCase()) ||
    l.email?.toLowerCase().includes(search.toLowerCase())
  );

  const initials    = (name) => name?.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase() || "?";
  const avatarColors= ["#D97706","#0369A1","#059669","#7C3AED","#DC2626","#0891B2"];
  const avatarColor = (id) => avatarColors[id?.charCodeAt(0) % avatarColors.length] || "#D97706";

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes spin   { to{transform:rotate(360deg)} }
        *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; background:#FAF7F4; }
        .sidebar { width:220px; flex-shrink:0; background:#fff; border-right:1.5px solid #E7E5E4; padding:24px 14px; display:flex; flex-direction:column; gap:6px; position:sticky; top:0; height:100vh; overflow-y:auto; }
        .topbar  { display:none; }
        .hamburger { display:none; align-items:center; justify-content:center; width:40px; height:40px; border-radius:10px; border:1.5px solid #E7E5E4; background:#fff; cursor:pointer; flex-shrink:0; }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.4); z-index:40; }
        .nav-btn { display:flex; align-items:center; gap:9px; width:100%; padding:10px 12px; border-radius:10px; border:none; background:none; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; font-weight:600; color:#78716C; cursor:pointer; transition:background .15s,color .15s; text-align:left; }
        .nav-btn:hover,.nav-btn.active { background:#FEF3C7; color:#D97706; }
        .nav-btn.danger:hover { background:#FEF2F2; color:#DC2626; }
        .search-input { width:100%; padding:11px 16px 11px 40px; background:#fff; border:1.5px solid #E7E5E4; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; color:#1C1917; outline:none; transition:border-color .2s; }
        .search-input:focus { border-color:#D97706; box-shadow:0 0 0 3px rgba(217,119,6,.1); }
        .search-input::placeholder { color:#A8A29E; }
        .labour-row { display:grid; grid-template-columns:2.5fr 2.5fr 1.2fr 1fr; align-items:center; padding:14px 18px; border-bottom:1px solid #F5F5F4; transition:background .15s; }
        .labour-row:hover { background:#FFFBF7; }
        .labour-row:last-child { border-bottom:none; }
        .btn-restore { padding:6px 12px; border-radius:8px; border:1.5px solid #A7F3D0; background:#D1FAE5; font-family:'Plus Jakarta Sans',sans-serif; font-size:11px; font-weight:700; color:#059669; cursor:pointer; transition:all .15s; }
        .btn-restore:hover { background:#A7F3D0; }
        .labour-cards { display:none; }
        @media (max-width:768px) {
          .sidebar { position:fixed; left:0; top:0; z-index:50; transform:translateX(-100%); transition:transform .28s ease; height:100%; }
          .sidebar.open { transform:translateX(0); }
          .sidebar-overlay.open { display:block; }
          .topbar { display:flex; align-items:center; gap:12px; padding:14px 16px; background:#fff; border-bottom:1.5px solid #E7E5E4; position:sticky; top:0; z-index:30; }
          .hamburger { display:flex; }
          .main-wrap { flex-direction:column !important; }
          .main-content { padding:16px !important; }
          .desktop-table { display:none !important; }
          .labour-cards { display:flex !important; flex-direction:column; gap:10px; }
        }
        @media (min-width:769px) and (max-width:1100px) { .sidebar { width:190px; } }
        @media (max-width:420px) { .main-content { padding:12px !important; } }
      `}</style>

      <div className="main-wrap" style={{ display:"flex", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", backgroundColor:"#FAF7F4" }}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={() => setSidebarOpen(false)} />

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"28px", padding:"0 4px" }}>
            <div style={{ width:"36px", height:"36px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ fontSize:"18px" }}>🪚</span>
            </div>
            <div>
              <p style={{ fontWeight:"800", fontSize:"15px", color:"#1C1917" }}>Craftigo</p>
              <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"500" }}>Carpenter Panel</p>
            </div>
          </div>
          <p style={{ fontSize:"11px", fontWeight:"700", color:"#C4B5A4", letterSpacing:"0.7px", textTransform:"uppercase", padding:"0 6px", marginBottom:"6px" }}>Menu</p>
          {navItems.map((n) => (
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`}
              onClick={() => { navigate(n.path); setSidebarOpen(false); }}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{ flex:1 }} />
          <div style={{ padding:"12px", background:"linear-gradient(135deg,#FEF3C7,#FFF7ED)", borderRadius:"12px", border:"1px solid #FDE68A", marginBottom:"10px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#92400E" }}>🪚 Carpenter</p>
            <p style={{ fontSize:"11px", color:"#B45309", marginTop:"2px" }}>Manage your team</p>
          </div>
          <button className="nav-btn danger" onClick={() => { localStorage.clear(); navigate("/login"); }}>🚪 Logout</button>
        </aside>

        {/* RIGHT */}
        <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6"  x2="21" y2="6"  stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{ fontWeight:"800", fontSize:"16px", color:"#1C1917" }}>♻️ Inactive Labours</span>
          </div>

          <main className="main-content" style={{ padding:"28px 32px", flex:1, overflowY:"auto" }}>

            {/* Back button */}
            <div style={{ marginBottom:"20px", animation:"fadeUp .3s ease both" }}>
              <button onClick={() => navigate("/carpenter/labours")}
                style={{ display:"inline-flex", alignItems:"center", gap:"6px", padding:"7px 14px", background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"10px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"600", color:"#78716C", cursor:"pointer" }}>
                ← Back to Labours
              </button>
            </div>

            {/* Header */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"20px", animation:"fadeUp .35s .05s ease both" }}>
              <div>
                <h1 style={{ fontSize:"24px", fontWeight:"800", color:"#1C1917", letterSpacing:"-0.5px" }}>Inactive Labours</h1>
                <p style={{ fontSize:"13px", color:"#A8A29E", marginTop:"3px" }}>
                  {loading ? "Loading…" : `${filtered.length} removed labours`}
                </p>
              </div>
              <button onClick={fetchInactiveLabours}
                style={{ padding:"10px 14px", background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"700", color:"#44403C", cursor:"pointer" }}>
                🔄 Refresh
              </button>
            </div>

            {/* Info banner */}
            <div style={{ background:"#EDE9FE", border:"1.5px solid #DDD6FE", borderRadius:"12px", padding:"12px 16px", marginBottom:"16px", display:"flex", alignItems:"center", gap:"10px", animation:"fadeUp .4s .08s ease both" }}>
              <span style={{ fontSize:"18px" }}>ℹ️</span>
              <p style={{ fontSize:"13px", color:"#5B21B6", fontWeight:"600" }}>
                These labours have been removed. Restore them to make them active again.
              </p>
            </div>

            {/* Search */}
            <div style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"16px", padding:"14px 16px", marginBottom:"16px", animation:"fadeUp .4s .1s ease both" }}>
              <div style={{ position:"relative" }}>
                <span style={{ position:"absolute", left:"13px", top:"50%", transform:"translateY(-50%)", pointerEvents:"none" }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="8" stroke="#A8A29E" strokeWidth="2"/>
                    <path d="m21 21-4.35-4.35" stroke="#A8A29E" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </span>
                <input className="search-input" type="text" placeholder="Search by name or email…" value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>

            {/* DESKTOP TABLE */}
            <div className="desktop-table" style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"16px", overflow:"hidden", animation:"fadeUp .4s .12s ease both" }}>
              <div style={{ display:"grid", gridTemplateColumns:"2.5fr 2.5fr 1.2fr 1fr", padding:"12px 18px", background:"#FAF7F4", borderBottom:"1.5px solid #E7E5E4" }}>
                {["Name","Email","Daily Rate","Actions"].map((h) => (
                  <span key={h} style={{ fontSize:"11px", fontWeight:"700", color:"#A8A29E", letterSpacing:"0.6px", textTransform:"uppercase" }}>{h}</span>
                ))}
              </div>

              {loading ? (
                <div style={{ padding:"48px", textAlign:"center" }}>
                  <div style={{ width:"32px", height:"32px", border:"3px solid #FDE68A", borderTop:"3px solid #D97706", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto 12px" }} />
                  <p style={{ color:"#A8A29E", fontSize:"14px" }}>Loading…</p>
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding:"56px", textAlign:"center" }}>
                  <p style={{ fontSize:"40px", marginBottom:"12px" }}>♻️</p>
                  <p style={{ color:"#78716C", fontWeight:"700", fontSize:"16px" }}>
                    {search ? "No labours found" : "No inactive labours"}
                  </p>
                  <p style={{ color:"#A8A29E", fontSize:"13px", marginTop:"4px" }}>
                    {search ? "Try different keywords" : "All your labours are currently active"}
                  </p>
                </div>
              ) : (
                filtered.map((l) => {
                  const c = avatarColor(l._id);
                  return (
                    <div key={l._id} className="labour-row" style={{ display:"grid", gridTemplateColumns:"2.5fr 2.5fr 1.2fr 1fr", alignItems:"center", opacity:0.75 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                        <div style={{ width:"36px", height:"36px", borderRadius:"50%", background:"#F5F5F4", border:"1.5px solid #E7E5E4", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"13px", fontWeight:"800", color:"#A8A29E", flexShrink:0 }}>
                          {initials(l.name)}
                        </div>
                        <div>
                          <span style={{ fontSize:"14px", fontWeight:"600", color:"#44403C" }}>{l.name}</span>
                          <span style={{ display:"block", fontSize:"10px", fontWeight:"700", color:"#DC2626", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:"20px", padding:"1px 6px", marginTop:"2px", width:"fit-content" }}>
                            Inactive
                          </span>
                        </div>
                      </div>
                      <span style={{ fontSize:"13px", color:"#A8A29E", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{l.email}</span>
                      <span style={{ fontSize:"13px", fontWeight:"700", color:"#A8A29E" }}>₹{l.dailyRate ?? "—"}/day</span>
                      <div>
                        <button className="btn-restore" onClick={() => restoreLabour(l._id)}>
                          ♻️ Restore
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* MOBILE CARDS */}
            <div className="labour-cards">
              {loading ? (
                <div style={{ padding:"48px", textAlign:"center" }}>
                  <div style={{ width:"32px", height:"32px", border:"3px solid #FDE68A", borderTop:"3px solid #D97706", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto" }} />
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding:"52px", textAlign:"center" }}>
                  <p style={{ fontSize:"36px", marginBottom:"10px" }}>♻️</p>
                  <p style={{ color:"#78716C", fontWeight:"700", fontSize:"15px" }}>No inactive labours</p>
                </div>
              ) : filtered.map((l) => {
                const c = avatarColor(l._id);
                return (
                  <div key={l._id} style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"14px", padding:"16px", display:"flex", alignItems:"center", gap:"12px", opacity:0.85 }}>
                    <div style={{ width:"46px", height:"46px", borderRadius:"50%", background:"#F5F5F4", border:"1.5px solid #E7E5E4", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"16px", fontWeight:"800", color:"#A8A29E", flexShrink:0 }}>
                      {initials(l.name)}
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <p style={{ fontSize:"14px", fontWeight:"700", color:"#44403C", marginBottom:"2px" }}>{l.name}</p>
                      <p style={{ fontSize:"12px", color:"#A8A29E", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{l.email}</p>
                      <span style={{ fontSize:"11px", fontWeight:"700", color:"#DC2626", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:"20px", padding:"1px 6px" }}>Inactive</span>
                    </div>
                    <button className="btn-restore" onClick={() => restoreLabour(l._id)}>♻️</button>
                  </div>
                );
              })}
            </div>

          </main>
        </div>
      </div>
    </>
  );
}